module.exports = __webpack_public_path__ + "static/img/nausicaa_cavalry_rider.ad04b56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/nausicaa_cavalry_rider.png
// module id = USCG
// module chunks = 0